<template>
  <div>
    <div class="main">
      <div class="heard">
        解绑手机号
      </div>
      <div class="conter">
        <el-form :label-position="labelPosition" :rules="rules" label-width="106px" :model="modification">
          <el-form-item label="手机号码：" prop="newphone">
            <el-input v-model="modification.newphone" ></el-input>
            <div class="formrightbox formrightboxb">
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-input v-model="modification.code" placeholder="请输入验证码" style="width:50%;float:left;"></el-input>
            <el-button type="primary" class="" @click="sendCode()" :disabled="isDisabled" style="float: right;">{{buttonName}}</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btn" @click="bindPhone()">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../static/config.json";
export default {
  name: "phone",
  data() {
    var reg = /^1[345678]\d{9}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    return {
      labelPosition: "right",
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      codephone: false,
      modification: {
        oldphone: "18888888888",
        newphone: "",
        code: ""
      },
      rules: {
        newphone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ]
      }
    };
  },
  mounted() {},
  methods: {
    // 发送验证码
    sendCode() {
      if (this.codephone == true) {
        this.sendMsg();
        var _this = this;
        let url =
          api.AgentApiUrl +
          "login/SendVerifyCodeToPhone/" +
          _this.$store.state.inscode;
        $.ajax({
          type: "POST",
          url: url,
          async: true,
          data: {
            phone: this.modification.newphone
          },
          success: function(data) {
            if (data.Ret == 0) {
              this.$message.success("验证码发送成功!");
            } else {
              this.$message.error(response.Msg);
            }
          }
        });
      }
    },
    //绑定手机号
    bindPhone() {
      if (this.modification.code == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      this.loading = true;
      let url = "/Account/BindPhone";
      let postData = {
        Phone: this.modification.newphone,
        Code: this.modification.code
      };
      console.log(postData);
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          this.$message.success("手机号码绑定成功!");
          this.$router.push("/index");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）重新发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 10;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #fff;
  margin: 30px 76px 73px 30px;
  box-shadow: 0 0 8px 3px rgba(97, 163, 255, 0.15);
}
.heard {
  height: 56px;
  font-size: 16px;
  padding: 21px 0 0 23px;
  border-bottom: 2px solid #d0dff5;
}
.conter {
  width: 470px;
  margin: 0 auto;
  text-align: center;
  margin-top: 84px;
}
.conter img {
  margin: 100px 0 73px 0;
}
.conter p {
  margin-left: -140px;
}
.btn {
  width: 246px;
  height: 60px;
  font-size: 18px;
  margin-top: 80px;
  margin-bottom: 320px;
}
.formrightbox {
  position: absolute;
  right: -130px;
  top: 0px;
}
.formrightbox .formbtn {
  color: #409eff;
  border: 0;
}
.formrightboxb {
  right: -62px;
}
</style>



// WEBPACK FOOTER //
// src/components/modification/unbindphone.vue